import { Http } from "./http.init";
import { assert } from "@/core";
export class ExportService {
  static async exportExcel(pathPrefix, payload = {}, type = "xlsx") {
    assert.string(pathPrefix, { required: true });
    assert.object(payload, { required: true });
    const response = await new Http({ auth: true, responseType: "blob" }).get(
      `/export/excel`
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${this.path}.${type}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
